/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_S3Inputs */

const en_vc_status_s3 = /** @type {(inputs: Vc_Status_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ready for real work for a mainstream illustrator`)
};

const zh_vc_status_s3 = /** @type {(inputs: Vc_Status_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可满足主流插画师的实际工作需求`)
};

/**
* | output |
* | --- |
* | "ready for real work for a mainstream illustrator" |
*
* @param {Vc_Status_S3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_s3 = /** @type {((inputs?: Vc_Status_S3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_S3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_s3(inputs)
	return zh_vc_status_s3(inputs)
});
export { vc_status_s3 as "vc.status.s3" }